import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    children: [
      {
        component: () => import('#/views/auto-rules/rule-management/index.vue'),
        meta: {
          icon: 'mdi:file-cog-outline',
          keepAlive: true,
          title: '规则管理',
        },
        name: 'AdAutoRuleManagement',
        path: '/auto-rule-management',
      },
      {
        component: () => import('#/views/auto-rules/execution-log/index.vue'),
        meta: {
          icon: 'mdi:history',
          keepAlive: true,
          title: '执行日志',
        },
        name: 'AdAutoRuleExecutionLog',
        path: '/auto-rule-execution-log',
      },
      {
        component: () => import('#/views/auto-rules/statistics/index.vue'),
        meta: {
          icon: 'mdi:chart-box-outline',
          keepAlive: true,
          title: '数据统计',
        },
        name: 'AdAutoRuleStatistics',
        path: '/auto-rule-statistics',
      },
      {
        component: () =>
          import('#/views/auto-rules/template-management/index.vue'),
        meta: {
          icon: 'mdi:file-document-edit-outline',
          keepAlive: true,
          title: '模板管理',
        },
        name: 'AdAutoRuleTemplateManagement',
        path: '/auto-rule-template-management',
      },
    ],
    meta: {
      icon: 'mdi:robot-outline',
      order: 85,
      title: '自动规则',
    },
    name: 'AdAutoRules',
    path: '/auto-rules',
  },
]

export default routes
